import type { IconData } from '@stacksjs/iconify-core'

export const flipHorizontalCircle1: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M20.914 3.202C22.044 3.036 23 3.955 23 5.096v37.808c0 1.141-.957 2.06-2.086 1.894C10.78 43.304 3 34.562 3 24C3 13.44 10.78 4.696 20.914 3.202m12.879 2.195A20.8 20.8 0 0 0 29 3.577m9.667 5.376a21.1 21.1 0 0 1 4.178 5.759m1.852 5.705c.2 1.165.304 2.362.304 3.583s-.104 2.419-.304 3.583m-10.904 15.02A20.8 20.8 0 0 1 29 44.424m9.667-5.377a21.1 21.1 0 0 0 4.178-5.758\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default flipHorizontalCircle1
